module.exports = require("url-parse");


//////////////////
// WEBPACK FOOTER
// external "url-parse"
// module id = 144
// module chunks = 0